import React from "react";
import { useTranslation } from "react-i18next";
import { DollarSign } from "lucide-react";

const FIELDS = [
  { key: "rate_30min",   tk: "profile.tariff_30min" },
  { key: "rate_1h",      tk: "profile.tariff_1h" },
  { key: "rate_2h",      tk: "profile.tariff_2h" },
  { key: "rate_overnight", tk: "profile.tariff_overnight" },
  { key: "rate_outcall", tk: "profile.tariff_outcall" },
];

export default function TariffsSection({ profile }) {
  const { t } = useTranslation();
  if (!profile) return null;
  const cur = (profile.rate_currency || "MXN").toUpperCase();
  const items = FIELDS
    .map((f) => ({ ...f, label: t(f.tk), value: profile[f.key] || 0 }))
    .filter((f) => f.value > 0);

  if (items.length === 0) return null;

  return (
    <div
      className="p-5"
      style={{ background: "var(--bg-surface)", border: "1px solid var(--vip-gold)" }}
      data-testid="tariffs-section"
    >
      <div className="overline mb-3 inline-flex items-center gap-2" style={{ color: "var(--vip-gold)" }}>
        <DollarSign size={14} /> {t("profile.tariffs_title")}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {items.map((it) => (
          <div
            key={it.key}
            className="flex items-baseline justify-between py-2"
            style={{ borderBottom: "1px solid var(--border-subtle)" }}
            data-testid={`tariff-${it.key}`}
          >
            <span className="text-sm" style={{ color: "var(--text-secondary)" }}>{it.label}</span>
            <span className="font-serif text-xl" style={{ color: "var(--text-primary)" }}>
              ${it.value.toLocaleString("es-MX")} <span className="text-xs" style={{ color: "var(--text-muted)" }}>{cur}</span>
            </span>
          </div>
        ))}
      </div>
      {profile.rate_notes && (
        <p className="text-xs mt-3" style={{ color: "var(--text-muted)", lineHeight: 1.6 }}>
          {profile.rate_notes}
        </p>
      )}
      <p className="text-[10px] mt-3" style={{ color: "var(--text-muted)" }}>
        {t("profile.tariff_disclaimer")}
      </p>
    </div>
  );
}
